import React from 'react';
import introImage from "../../images/Logo.png";

const PublicHeader = () => {


    return (
        <header
            className="sl-header sl-border-bottom sl-bg-white sl-min-h-18 sl-flex sl-justify-center sl-gap-2-point-5 sl-items-center">
            <div className="sl-container">
                <div className="sl-row sl-flex sl-justify-center sl-content-center">

                    <img src={introImage} alt={'ShortLister Logo'}/>


                </div>
            </div>
        </header>
    );
};

export default PublicHeader;
